

import TFACtivityModel from './activitiesUi/mcq/model/TFACtivityModel'
import axios from 'axios'
import Activity from './activitiesUi/activity/model/Activity';
import DragWordToImgActivity from './activitiesUi/ddTxtImg/model/DragWordToImgActivity'
import SortStoryActivity from './activitiesUi/ddSortStory/model/SortStoryActivity';
import DragDropParagraphActivity from './activitiesUi/ddp/model/DragDropParagraphActivity'
import WordOnImgActvity from './activitiesUi/wordOnImg/model/WordOnImgActvity'
import CompareActivity from './activitiesUi/compare/model/CompareActivity';
import ClassificationActivity from './activitiesUi/classification/model/ClassificationActivity';
import ConnectActivity from "./activitiesUi/connect/model/ConnectActivity";
import WriteMissingWordsActivity from "./activitiesUi/writeMissingWords/model/WriteMissingWordsActivity";

class QuizViewerModel {


    constructor() {
        this.TF_ACTIVITY_TYPE = 0;
        this.DRAG_DROP_PARAGRAPH_ACTIVITY_TYPE = 1
        this.activityArr = []
        this.currentActivity = -1;
        this.appName = "item_63";
        this.showResultPage = false;
        this.reviewMode = false;
        this.callback = null
        this.selectedStyle = null;
        this.ARABIC_LANG = 0
        this.ENGLISH_LANG = 1
        this.currentLang = this.ARABIC_LANG
        this.projectPlugin = null;
        this.total = 0
        this.degree = 0
        this.callbackData = {
            studentId: 0,
            topicId: 0,
            courseId: 0,
            quizId: 0,
            showReport: false
        }
        this.timeTaken = 0
    }



    initRes = () => {
        this.imgRes = window.resBaseUrl + this.appName + "/assets/appImgs/"
        this.soundRes = window.resBaseUrl + this.appName + "/assets/appSounds/"

    }


    gotoNext = (callback) => {
        if (this.currentActivity < this.activityArr.length - 1) {
            this.currentActivity++
        }
        else {
            window.clearInterval(window.timeTakenTimer)

            this.showResultPage = true
            this.reviewMode = true;
            this.callbackData.showReport = "true"

            this.finalCallBack(callback);
            // if (this.callback != null) {
            //     this.finalCallBack();
            // }
        }
    }

    gotoPrev = () => {
        if (this.currentActivity > 0) {
            this.currentActivity--
        }

    }


    finalCallBack = (callback) => {

        console.log("finalCallBack")

        this.degree = this.getDegree()
        this.total = this.activityArr.length

        let report = this.getReportAsJson()


        // let report={degree:this.degree,total:this.total}

        // console.log(report)

        if (this.callback != null) {
            this.callback(JSON.stringify(report), callback)
        }
        // this.callback(report)
    }

    reviewActivity = (index) => {
        this.currentActivity = index;
        this.showResultPage = false

    }

    resetApp = () => {
        this.currentActivity = 0;
        this.showResultPage = false
        this.reviewMode = false;

        for (let i = 0; i < this.activityArr.length; i++) {
            this.activityArr[i].resetActivity();
        }

    }

    openApp = (callback) => {


        let data = new FormData();

        data.append("appName", this.appName);

        let url = window.baseUrl + "open.php"



        axios({
            url: url,

            data: data,
            method: 'post'
        })
            .then(res => {
                callback(res);
            })

    }

    getTest4You = (quizId, callback) => {


        axios({
            method: 'post',
            // url: 'http://localhost:8012/revision-php/ws/quizBuilder/QuizWS.php?method=generateQuestionList&quizId='+quizId,
            url: 'https://nafes.app/revision/revision-php/ws/quizBuilder/QuizWS.php?method=generateQuestionListLite&quizId=' + quizId,

            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });
    }

    // getItemReport = (quizId, studentId, callback) => {

    //     let data = new FormData();

    //     data.append("itemId", quizId);
    //     data.append("studentId", studentId);

    //     axios({
    //         method: 'post',
    //         url: 'https://nafes.app/revision/revision-php/ws/user/StudentWS.php?method=getItemReport',
    //         data: data,
    //         headers: {
    //             "Content-type": 'application/x-www-form-urlencoded'
    //         }

    //     }).then((res) => {


    //         if (res.data.report && res.data.report != null) {
    //             debugger
    //             res.data.report = (res.data.report.substring(1))
    //             res.data.report = res.data.report.substring(0, res.data.report.length - 1)
    //             let report = JSON.parse(res.data.report)
    //             this.total = report.total
    //             this.degree = report.degree
    //             if (report.timeTaken)
    //                 this.timeTaken = report.timeTaken
    //             let resultData = report.activityArr
    //             let idList = []
    //             resultData.map((item) => {
    //                 idList.push(item.activityId)
    //             })
    //             this.getQuizListWithIds(idList, (response2) => {
    //                 console.log(response2)


    //                 let { questionListJson } = response2.data
    //                 for (let i = 0; i < resultData.length; i++) {

    //                     let activityObj = {}
    //                     questionListJson.map((item) => {
    //                         if (item.qId == resultData[i].activityId) {
    //                             let activityObj = JSON.parse(item.questionJson)

    //                             let activity = new Activity()
    //                             if (activityObj.activityType == activity.CONNECT)
    //                                 activityObj.activityType = activity.COMPARE
    //                             activity = this.createActivityWithType(activityObj.activityType)
    //                             activity.activityId = item.qId
    //                             activity.loList = item.loList
    //                             activity.difficulty=item.difficulty
    //                             activity.cognitiveId=item.cognitiveId


    //                             if (activityObj.test4you) {
    //                                 activity.initFromJsonTest4You(activityObj)
    //                             }

    //                             activity.initReportFromJson(resultData[i])
    //                             activity.activityIndex = i
    //                             this.activityArr.push(activity)
    //                         }
    //                     })


    //                 }

    //                 console.log(this.activityArr)
    //                 callback(res);

    //             })
    //         }
    //     })
    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // }
    getQuizListWithIds = (idList, callback) => {
        let data = new FormData();

        data.append("idList", idList);

        axios({
            method: 'post',
            url: 'https://nafes.app/revision/revision-php/ws/quizBuilder/QuizWS.php?method=getQuizListWithIds',
            data: data,
            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            // console.log(response)
            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });
    }




    getItemReport = (quizId, studentId, callback) => {

        this.activityArr = [];
        let url = "https://nafes.app/revision/revision-php/ws/user/StudentWS.php?method=getItemReport";

        let data = new FormData();

        data.append("itemId", quizId);
        data.append("studentId", studentId);


        axios({
            method: 'post',
            url: url,
            data: data,
            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then((response) => {


            let object = response.data;

            if (object.report) {

                let reportJson = object.report;
                reportJson = (reportJson.substring(1));
                reportJson = reportJson.substring(0, reportJson.length - 1);

                let report = JSON.parse(reportJson);
                this.total = report.total;
                this.degree = report.degree;

                if (report.timeTaken)
                    this.timeTaken = report.timeTaken;

                let resultData = report.activityArr;
                let idList = [];

                for (let i = 0; i < resultData.length; i++) {
                    idList[i] = resultData[i].activityId;
                }


                this.getQuizListWithIds(idList, (res) => {


                    let data = res.data;
                    let questionListJson = data.questionListJson;

                    for (let i = 0; i < resultData.length; i++) {

                        for (let j = 0; j < questionListJson.length; j++) {
                            let item = questionListJson[j];
                            if (item.qId == resultData[i].activityId) {
                                let activityObj = JSON.parse(item.questionJson);

                                let activity = this.createActivityWithType(activityObj.activityType)


                                activity.activityId = item.qId;
                                activity.activityKey = item.qKey;
                                activity.difficulty = item.difficulty;
                                activity.cognitiveId = item.cognitiveId;

                                if (activityObj.qCatId)
                                    activity.catId = item.qCatId;
                                activity.questionType = item.questionType;

                                let loListJson = item.loList;
                                activity.loList = item.loList
                                activity.initFromJsonTest4You(activityObj);


                                activity.initReportFromJson(resultData[i]);
                                activity.activityIndex = i;
                                this.activityArr.push(activity);
                            }
                        }
                    }


                    callback();
                })
            }

        })
    }


    //  getQuizListWithIds=(idList,callback)=> {

    //     let url = "https://nafes.app/revision/revision-php/ws/quizBuilder/QuizWS.php?method=getQuizListWithIdsLite";

    //     AQuery aq = new AQuery(context);
    //     Map<String, String> params = new HashMap<>();

    //     String idListStr = "";

    //     for (int i = 0; i < idList.length; i++) {
    //         idListStr += idList[i];
    //         if (i < idList.length - 1)
    //             idListStr += ",";
    //     }

    //     params.put("idList", idListStr);

    //     aq.ajax(url)
    //             .postForm(params)
    //             //.showLoading()
    //             .response((response, error) -> {
    //                 // Do stuff
    //                 System.out.println("getTest4You response : " + response.toString());
    //                 try {
    //                     callback.callback(response);
    //                 } catch (JSONException e) {
    //                     e.printStackTrace();
    //                 }

    //             });
    // }




    getDegree = () => {
        let degree = 0;
        for (let i = 0; i < this.activityArr.length; i++) {
            if (this.activityArr[i].answeredTrue)
                degree++
        }
        return degree
    }



    getPoints = () => {
        let initialPoints = 5;
        let totalPoints = 0
        let totalRight = 0

        this.activityArr.map((q, index) => {
            if (q.answeredTrue) {
                totalRight++
            }
        });

        if (this.callbackData.isExam == "true") {
            totalPoints = totalRight + initialPoints
        }

        else {
            totalPoints = initialPoints

        }


        return totalPoints
    }

    getReportAsJson = () => {

        let obj = {}
        obj.appName = this.appName
        obj.degree = this.getDegree()
        obj.total = this.activityArr.length
        obj.timeTaken = this.timeTaken
        obj.activityArr = []

        for (let i = 0; i < this.activityArr.length; i++) {

            obj.activityArr.push(this.activityArr[i].getReportAsJson())
        }

        obj.currentLang = this.currentLang
        obj.projectPlugin = this.projectPlugin
        obj.selectedStyle = this.selectedStyle
        return obj

    }

    initReportFromJson = (obj) => {

        this.appName = obj.appName;
        this.projectPlugin = obj.projectPlugin
        this.degree = obj.degree
        this.total = obj.total
        if (obj.timeTaken)
            this.timeTaken = obj.timeTaken
        else
            this.timeTaken = -1

        let activityConst = new Activity()
        for (let i = 0; i < obj.activityArr.length; i++) {
            let activity = new Activity();
            if (obj.activityArr[i].activityType === activityConst.TF_ACTIVITY_TYPE) {
                activity = new TFACtivityModel();
            }
            else if (obj.activityArr[i].activityType === activityConst.DRAG_WORD_TO_IMG) {
                activity = new DragWordToImgActivity();
            }
            else if (obj.activityArr[i].activityType === activityConst.SORT_STORY) {
                activity = new SortStoryActivity();
            } else if (obj.activityArr[i].activityType === activityConst.DRAG_DROP_PARGRAPH) {
                activity = new DragDropParagraphActivity();
                //activity.activityIndex = i;
            } else if (obj.activityArr[i].activityType == activityConst.WORD_ON_IMG) {
                activity = new WordOnImgActvity();
            }
            else if (obj.activityArr[i].activityType == activityConst.COMPARE) {
                activity = new CompareActivity();
            }
            else if (obj.activityArr[i].activityType == activityConst.CLASSIFICATION) {
                activity = new ClassificationActivity();
            }
            else if (obj.activityArr[i].activityType == activityConst.CONNECT) {
                activity = new ConnectActivity();
            }
            else if (obj.activityArr[i].activityType == activityConst.WRITE_MISSING_WORDS) {
                activity = new WriteMissingWordsActivity();
            }

            this.selectedStyle = obj.selectedStyle
            activity.activityIndex = i;

            activity.initReportFromJson(obj.activityArr[i])
            this.activityArr.push(activity);
            console.log(i)
        }


        this.initActivitiesSharedItems();

    }


    getAsJson = () => {
        let obj = {}
        obj.appName = this.appName
        obj.activityArr = []


        obj.timeTaken = this.timeTaken

        for (let i = 0; i < this.activityArr.length; i++) {

            obj.activityArr.push(this.activityArr[i].getAsJson())
        }

        obj.selectedStyle = this.selectedStyle

        return obj
    }


    getTotalinDetails = () => {
        this.totalRight = 0;
        this.totalWrong = 0;
        this.totalSkipped = 0;


        this.activityArr.map((q, index) => {
            if (q.answeredTrue) {
                this.totalRight++
            }
            else if (q.isSkipped) {
                this.totalSkipped++
            }

            else {
                this.totalWrong++
            }
        })
    }



    initFromJson = (obj) => {

        this.appName = obj.appName;
        if (obj.timeTaken)
            this.timeTaken = obj.timeTaken
        else
            this.timeTaken = -1

        let activityConst = new Activity()
        for (let i = 0; i < obj.activityArr.length; i++) {
            let activity = new Activity();
            if (obj.activityArr[i].activityType === activityConst.TF_ACTIVITY_TYPE) {
                activity = new TFACtivityModel();
            }
            else if (obj.activityArr[i].activityType === activityConst.DRAG_WORD_TO_IMG) {
                activity = new DragWordToImgActivity();
            }
            else if (obj.activityArr[i].activityType === activityConst.SORT_STORY) {
                activity = new SortStoryActivity();
            } else if (obj.activityArr[i].activityType === activityConst.DRAG_DROP_PARGRAPH) {
                activity = new DragDropParagraphActivity();
                // activity.activityIndex = i;
            }
            else if (obj.activityArr[i].activityType == activityConst.WORD_ON_IMG) {
                console.log(obj.activityArr[i])
                activity = new WordOnImgActvity();
            }
            else if (obj.activityArr[i].activityType == activityConst.COMPARE) {
                activity = new CompareActivity();
            }
            else if (obj.activityArr[i].activityType == activityConst.CLASSIFICATION) {
                activity = new ClassificationActivity();
            }
            else if (obj.activityArr[i].activityType == activityConst.CONNECT) {
                activity = new ConnectActivity();
            }
            else if (obj.activityArr[i].activityType == activityConst.WRITE_MISSING_WORDS) {
                activity = new WriteMissingWordsActivity();
            }
            activity.activityIndex = i;
            activity.initFromJson(obj.activityArr[i])

            this.activityArr.push(activity);
        }


        this.initActivitiesSharedItems();

        this.selectedStyle = obj.selectedStyle
        this.projectPlugin = obj.projectPlugin;


    }
    createActivityWithType = (activityType) => {
        let activity = null;
        let activityStatic = new Activity();
        if (activityType == activityStatic.DRAG_WORD_TO_IMG) {
            activity = new DragWordToImgActivity();
        } else if (activityType == activityStatic.TF_ACTIVITY_TYPE) {
            activity = new TFACtivityModel();
        } else if (activityType == activityStatic.SORT_STORY) {
            activity = new SortStoryActivity();
        } else if (activityType == activityStatic.DRAG_DROP_PARGRAPH) {
            activity = new DragDropParagraphActivity();
            activity.dropItemContainer.activityId = this.activityArr.length;
        } else if (activityType == activityStatic.WORD_ON_IMG) {
            activity = new WordOnImgActvity();
        } else if (activityType == activityStatic.COMPARE) {
            activity = new CompareActivity();
        } else if (activityType == activityStatic.CLASSIFICATION) {
            activity = new ClassificationActivity();
        }
        else if (activityType == activityStatic.CONNECT) {
            activity = new ConnectActivity();
        }
        else if (activityType == activityStatic.WRITE_MISSING_WORDS) {
            activity = new WriteMissingWordsActivity();
        }
        return activity;
    };


    initActivitiesSharedItems = () => {
        for (let i = 0; i < this.activityArr.length; i++) {
            this.activityArr[i].initSharedItems(this.activityArr);
        }
    }
}

export default QuizViewerModel